/**
 * intl-latam-ec-bg-mibg-api-link-form-bg
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ApiResponse } from '../model-formulario/apiResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../../environments/environment';

@Injectable()
export class NotificationsService {

    protected basePath = environment.URL_API_FORM;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param date 
     * @param lookupkey 
     * @param uniqueid 
     * @param evidencetype 
     * @param outcome 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcMilfListenEvicertiaForms(date?: string, lookupkey?: string, uniqueid?: string, evidencetype?: string, outcome?: string, observe?: 'body', reportProgress?: boolean): Observable<ApiResponse>;
    public intlLatamEcMilfListenEvicertiaForms(date?: string, lookupkey?: string, uniqueid?: string, evidencetype?: string, outcome?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiResponse>>;
    public intlLatamEcMilfListenEvicertiaForms(date?: string, lookupkey?: string, uniqueid?: string, evidencetype?: string, outcome?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiResponse>>;
    public intlLatamEcMilfListenEvicertiaForms(date?: string, lookupkey?: string, uniqueid?: string, evidencetype?: string, outcome?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }
        if (lookupkey !== undefined && lookupkey !== null) {
            queryParameters = queryParameters.set('lookupkey', <any>lookupkey);
        }
        if (uniqueid !== undefined && uniqueid !== null) {
            queryParameters = queryParameters.set('uniqueid', <any>uniqueid);
        }
        if (evidencetype !== undefined && evidencetype !== null) {
            queryParameters = queryParameters.set('evidencetype', <any>evidencetype);
        }
        if (outcome !== undefined && outcome !== null) {
            queryParameters = queryParameters.set('outcome', <any>outcome);
        }

        let headers = this.defaultHeaders;

        // authentication (basic-authorize) required
        // if (this.configuration.apiKeys["idToken"]) {
        //     queryParameters = queryParameters.set('idToken', this.configuration.apiKeys["idToken"]);
        // }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ApiResponse>(`${this.basePath}/notifications/evicertia`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public notificationsEvicertiaOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public notificationsEvicertiaOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public notificationsEvicertiaOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public notificationsEvicertiaOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<any>(`${this.basePath}/notifications/evicertia`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
